/**
 * 관리자 API axios 에러에서 사용자/운영자에게 보여줄 문구 추출 (토스 providerCode 포함)
 * 일부 라우트는 { message, error } 형태로 상세를 error에 둠
 */
export function formatAdminApiError(err) {
  const d = err?.response?.data;
  if (!d) return err?.message || '알 수 없는 오류';
  const primary = d.message || err?.message || '요청 실패';
  const extra =
    d.error != null && String(d.error) !== String(primary) ? String(d.error) : null;
  let msg = extra ? `${primary}\n${extra}` : primary;
  if (d.providerCode) {
    msg += ` (${d.providerCode})`;
  } else if (d.errorCode && d.errorCode !== 'UNKNOWN') {
    msg += ` [${d.errorCode}]`;
  }
  return msg;
}
